import React from "react";
import "./form-layout.css";

// Below both expanded and collapsed sidebars; shared by every editor page.
export default function FormActionBar({ children }) {
  return <footer className="admin-form-actions d-flex align-items-center justify-content-end flex-wrap gap-2">{children}</footer>;
}
